export const parsePage = page => ({
	...page,
	body: JSON.parse(page.body || '{}'),
});

export const EVENT_PAGES = `
	query eventPages($event_id: Uint) {
		eventPages(event_id: $event_id) {
			id
			name
			body
			theme
			widget_order
			widgets {
				id
				type
				props
				created_at
				updated_at
				groups {
					id
					name
				}
			}
			created_at
			updated_at
		}
	}
`;

export const PAGE = `
	query page($id: Uint) {
		page(id: $id) {
			id
			name
			body
			theme
			widget_order
			widgets {
				id
				type
				props
				created_at
				updated_at
				groups {
					id
					name
				}
			}
			created_at
			updated_at
		}
	}
`;
